import React from "react";
import Clinicinfo from "./components/clinic/clinicinfo";
import Patients from "./components/patients/patient-list";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "./index.css";
import Trials from "./components/trials/trials";
import EditClinic from "./components/clinic/edit-clinic";
import RecruiterList from "./components/recruiters/recruiters-list";
import EditRecruiters from "./components/recruiters/edit-recruiters";
import "./css/default.css";
import "./css/theme/purple.css";
import MasterLayout from "./components/layout/master-layout";
import AddRecruiter from "./components/recruiters/add-recruiter";
import AddClinic from "./components/clinic/add-clinic";
import EditPatient from "./components/patients/edit-patient";
import TrialStatuses from "./components/trials/trial-statuses";
import Workflow from "./components/workflow/workflow-list";
import Login from "./components/login/login";
import { useEffect, useRef } from "react";
import WorkflowFromScratch from "./components/workflow/workflow-from-scratch";
import Conversation from "./components/conversations/conversation";
import Dashboard from "./components/dashboard/dashboard";
import WorkflowDetails from "./components/workflow/workflow-details";
import ForgotPassword from "./components/login/forgot-password";
import PersonalInfo from "./components/personal-info/personal-info";
import EditPersonalInfo from "./components/personal-info/edit-personal-info";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchUserProfile,
  fetchUserPermission,
} from "./reducer/slices/user/userSlice";
import { getTrails } from "./reducer/slices/trial/get-trial-slice";
import { getTrailsName } from "./reducer/slices/trial/get-trial-name-slice";
import { getClinicInformation } from "./reducer/slices/clinic/get-clinicinfo-slice";
import { getRecruiterLists } from "./reducer/slices/recruiter/get-recruiter-slice";
import AddPatient from "./components/patients/add-patients";
import ResetPassword from "./components/login/reset-password";
import ConversationList from "./components/conversations/conversation-list";
import ConversationPatients from "./components/conversations/conversation-patients";
import IntegrationDashboard from "./components/integrations/integration-dashboard";
import Calendar from "./components/integrations/calendar/calendar";
import UserAccess from "./components/user-access/user-access";
import PrivateRoute from "./guards/private-route";
import AllowedAccess from "./guards/AllowedAccess";
import Permission from "./guards/PermissionList";
import { COMPONENTTYPE } from "./components/common/constant/componentType";
import { ROLES } from "./components/common/constant/roles";

//import PostLoginRedirect from './guards/PostLoginRedirect';

function App() {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    if (user.isAuthenticated) {
      dispatch(fetchUserProfile({}));
      dispatch(fetchUserPermission());
      dispatch(getTrails({}));
      dispatch(getClinicInformation({}));
      dispatch(getRecruiterLists({}));
      dispatch(getTrailsName({}));
    }
  }, [user.isAuthenticated]);
console.log('[Permission.root.trials_hub]', [Permission.root.trials_hub])
  return (
    <div className="App">
      {user.isAuthenticated && !user.isPermissionLoaded ? (
        <>
          <div class="spinnerwrapper">
            <div class="spinner"></div>
          </div>
        </>
      ) : (
        <>
          <Router>
            {/* <PostLoginRedirect /> */}
            <Routes>
              <Route
                path="/"
                element={
                  user.isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
              <Route
                path="/login"
                element={
                  user.isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <Login />
                  )
                }
              />
              <Route
                path="/forgot-password"
                element={
                  user.isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <ForgotPassword />
                  )
                }
              />
              <Route
                path="/reset-password/:token"
                element={
                  user.isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <ResetPassword />
                  )
                }
              />

              <Route
                element={
                  <PrivateRoute>
                    <MasterLayout />
                  </PrivateRoute>
                }
              >
                <Route
                  path="/dashboard"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.dashboard]}
                    >
                      <Dashboard />
                    </AllowedAccess>
                  }
                />
                <Route path="/user-access" element={
                  <AllowedAccess
                    type={COMPONENTTYPE.PAGE}
                     permissions={[Permission.root.admin_userAccess]}
                  >
                    <UserAccess /></AllowedAccess>
                } />
                <Route path="/personal-info" element={<PersonalInfo />} />
                <Route
                  path="/edit-personal-info"
                  element={<EditPersonalInfo />}
                />

                <Route path="/locations" element={<AllowedAccess type={COMPONENTTYPE.PAGE} roles={[ROLES.ADMIN]} permissions={[Permission.root.admin_location]}><Clinicinfo /></AllowedAccess>} />
                <Route path="/edit-location" element={<AllowedAccess type={COMPONENTTYPE.PAGE} roles={[ROLES.ADMIN]} permissions={[Permission.admin_location.edit_location]}><EditClinic /></AllowedAccess>} />
                <Route path="/add-location" element={<AllowedAccess type={COMPONENTTYPE.PAGE} roles={[ROLES.ADMIN]} permissions={[Permission.admin_location.add_location]}><AddClinic /></AllowedAccess>} />

                <Route path="/patients" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.root.patient]}><Patients /></AllowedAccess>} />
                <Route path="/edit-patient" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.patient.edit_patient]}><EditPatient /></AllowedAccess>} />
                <Route path="/add-patient" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.patient.add_patient]}><AddPatient /></AllowedAccess>} />

                <Route path="/recruiters" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.root.admin_recruiter]}><RecruiterList /></AllowedAccess>} />
                <Route path="/edit-recruiter" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.admin_recruiter.edit_recruiter]}><EditRecruiters /></AllowedAccess>} />
                <Route path="/add-recruiter" element={<AllowedAccess type={COMPONENTTYPE.PAGE} permissions={[Permission.admin_recruiter.add_recruiter]}><AddRecruiter /></AllowedAccess>} />

                <Route
                  path="/trials"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.trials_hub]}
                    >
                      <Trials />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/trial-statuses"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.trials_hub.trial_view]}
                    >
                      <TrialStatuses />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/trial-statuses/:key"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.trials_hub.trial_view]}
                    >
                      <TrialStatuses /></AllowedAccess>
                  }
                />

                <Route
                  path="/workflow"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.trials_hub]}
                    >
                      <Workflow />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/trial/:id?"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.trials_hub.edit_trial]}
                    >
                      <WorkflowDetails />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/create-trial"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.trials_hub.add_trial]}
                    >
                      <WorkflowFromScratch />
                    </AllowedAccess>
                  }
                />

                <Route
                  path="/conversations/:id"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.conversations]}
                    >
                      <Conversation />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/conversation-patients/:id"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.conversations]}
                    >
                      <ConversationPatients />
                    </AllowedAccess>
                  }
                />

                <Route
                  path="/conversation-list/:id?"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.conversations]}
                    >
                      <ConversationList />
                    </AllowedAccess>
                  }
                />

                <Route
                  path="/calendar"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[Permission.root.calendar]}
                    >
                      <Calendar />
                    </AllowedAccess>
                  }
                />
                <Route
                  path="/integrations"
                  element={
                    <AllowedAccess
                      type={COMPONENTTYPE.PAGE}
                      permissions={[
                        Permission.integration.facebook_integration,
                        Permission.integration.microsoft_calendar_integration,
                      ]}
                      isAuthMsg={true}
                    >
                      <IntegrationDashboard />
                    </AllowedAccess>
                  }
                />
              </Route>
            </Routes>
          </Router>
        </>
      )}
    </div>
  );
}

export default App;
